import { render, staticRenderFns } from "./ConceptProductDetailThai.vue?vue&type=template&id=70485044&"
import script from "./ConceptProductDetailThai.vue?vue&type=script&lang=js&"
export * from "./ConceptProductDetailThai.vue?vue&type=script&lang=js&"
import style0 from "./ConceptProductDetailThai.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports